import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../../../../config/queryKeys'
import { getOrgVenues } from '../../../../services/organization/orgVenuesService'
import type { OrgVenueApi } from '../types'
import { toOrgVenueOptions } from '../utils/venueOptions'

/** A venue list changes rarely; flipping between org tabs shouldn't refetch it. */
const STALE_TIME = 5 * 60 * 1000

/** An organization's venues as Location filter rows, sorted by name. */
export const useOrgVenueOptions = (orgId: string | undefined) => {
  'use memo'

  const query = useQuery<OrgVenueApi[]>({
    queryKey: queryKeys.venues.byOrg(orgId),
    queryFn: () => getOrgVenues(orgId as string),
    enabled: Boolean(orgId),
    staleTime: STALE_TIME,
  })

  return {
    options: toOrgVenueOptions(query.data ?? []),
    isLoading: query.isLoading,
    isError: query.isError,
  }
}
